<template>
  <div class="message message-bar" role="alert">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .message {
    background-color: color.adjust($green, $lightness: 50%);
  }
</style>
